import * as S from './styled';

function AccountStatBoxText ({ children }) {
  return <S.Container>
    {children}
  </S.Container>;
}

export default AccountStatBoxText;
